import { Link, Navigate } from "react-router-dom";
import { Car, CheckCircle2, ExternalLink, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { useJourney, useSite } from "@/lib/site";
import { telHref } from "@/lib/api";

export default function Sent() {
  const j = useJourney();
  const { cfg } = useSite();
  const sub = j.state.submitted;
  if (!sub) return <Navigate to="/" replace />;
  const priced = j.state.valuation?.status === "ok" && !j.state.manual;
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main className="mx-auto max-w-2xl px-4 py-10 sm:px-6" data-testid="confirmation-page">
        <CheckCircle2 className="h-10 w-10 text-brand-navy" aria-hidden />
        <h1 className="mt-4 text-3xl font-bold text-slate-900 sm:text-4xl">Thank you! We've received your enquiry.</h1>
        <p className="mt-4 text-lg text-slate-800" data-testid="confirmation-message">
          {priced
            ? "We'll review your vehicle details and contact you if we'd like to take things further. Your estimated valuation is not a confirmed purchase offer, so please don't visit the dealership until we've been in touch."
            : "Our team will review your vehicle personally and contact you if we'd like to take things further. Please don't visit the dealership until we've been in touch."}
        </p>
        <div className="panel mt-6 p-5">
          <p className="eyebrow">Your enquiry reference</p>
          <p className="mt-1 text-3xl font-bold tracking-wide text-slate-900" data-testid="confirmation-reference">{sub.reference}</p>
          <p className="mt-2 text-sm text-slate-600">Please keep this reference in case you need to contact us.</p>
        </div>
        <Button asChild size="lg" className="mt-6 h-12 w-full text-base font-semibold sm:w-auto sm:px-8">
          <a href="https://www.hcsales.co.uk/" target="_blank" rel="noopener noreferrer" data-testid="browse-our-cars-button"><Car className="mr-2 h-5 w-5" />Browse Our Cars<ExternalLink className="ml-2 h-4 w-4 opacity-80" /></a>
        </Button>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button variant="outline" asChild><a href={telHref(cfg.business.phone)} data-testid="confirmation-call-button"><Phone className="mr-1 h-4 w-4" />Call {cfg.business.phone}</a></Button>
          <Button variant="ghost" asChild><Link to="/" onClick={() => j.reset()} data-testid="confirmation-start-again">Value another car</Link></Button>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
